import { BadgeCheck } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "~/shadcn/ui/tooltip"

/**
 * "Founding Agency" checkmark shown next to a talent agency's name on the
 * Talent Agencies page. Renders nothing unless the agency has the flag enabled.
 * The global TooltipProvider is mounted in app.tsx.
 */
export const FoundingAgencyBadge = ({ show }: { show: boolean }) => {
  if (!show) return null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label="Founding Agency"
          tabIndex={0}
          className="inline-flex shrink-0 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2"
        >
          <BadgeCheck
            aria-hidden="true"
            className="h-4 w-4 text-defaultPrimary"
          />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p className="font-semibold">Founding Agency</p>
        <p>
          Recognized by Zano for their early partnership, founding agencies are
          talent agencies we confidently recommend partnering with.
        </p>
      </TooltipContent>
    </Tooltip>
  )
}
